import { cn } from '@/lib/utils';

export function Loader({ message, className, absolute }: { className?: string; message?: string; absolute?: boolean }) {
  return (
    <div className="grid min-h-dvh place-items-center">
      <div className="flex items-center gap-3">
        <div
          role="status"
          aria-live="polite"
          aria-busy="true"
          className={cn(
            'flex flex-col items-center justify-center gap-4 p-6',
            absolute && 'absolute inset-0 flex items-center justify-center',
            className,
          )}
        >
          {/* Spinner */}
          <div aria-hidden className="size-16 animate-spin rounded-full border-8 border-gray-200 border-t-violet-500" />
          {/* Message */}

          {message}
        </div>
      </div>
    </div>
  );
}
